import {useEffect, useState} from 'react'
// import * as Sentry from '@sentry/gatsby'

type Response = {
  inlineMessage: string
}

const useHobspot = (email: string) => {
  const [data, setData] = useState<Response>()
  const portalId = '20647882'
  const formId = '0b071cad-c7bd-44dd-9f2d-e1a822e2e1cf'
  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`
  const [form, setForm] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false)
      setIsLoading(true)
      try {
        const data = {
          fields: [{name: 'email', value: email}],
        }
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data),
          // @ts-ignore
          mode: 'no-cors',
          cache: 'no-cache',
        })
        const payload = await response.json()
        setData(payload)
        setForm(false)
      } catch (e) {
        // Sentry.captureException(e)
        console.error(e)
        setIsError(true)
        setForm(false)
      }

      setIsLoading(false)
    }
    if (form) {
      fetchData()
    }
  }, [form, email, url])

  const handleSubmit = () => {
    setForm(true)
  }

  return {data, isLoading, isError, handleSubmit}
}

export default useHobspot
